import '../../assets/css/style.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import React, { useState } from 'react';

import HeaderWebPage from './HeaderWebPage';
import FooterWebPage from './FooterWebPage';
import fotoAna from '../../assets/images/foto-ana.jpg';
import fotoCarlos from '../../assets/images/foto-carlos.jpg';
import logoStripe from '../../assets/images/logo-stripe.png';
import logoMelhorEnvio from '../../assets/images/logo-melhor-envio.png';
import googlePlay from '../../assets/images/get_it_on_google_play_new.png';
import appStore from '../../assets/images/get_it_on_app_store_new.png';
import mockup from '../../assets/images/mockup-tela-lojista.png';
import BackToTop from '../../components/templates/BackToTop';
import { captarLeadWeb } from '../../store/actions/negocio';
import { BUSINESS_HEADER_MENU_ITEMS } from '../shared/headerMenus';

const LandingPage = () => {
  const [formData, setFormData] = useState({
    nomeLoja: '',
    telefone: '',
    email: '',
    contato: ''
  });

  const [status, setStatus] = useState({ loading: false, message: '', type: '' });

  // Função para atualizar o estado conforme o usuário digita
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // Função de envio
  const handleSubmit = async (e) => {
    e.preventDefault(); // Impede o recarregamento da página
    setStatus({ loading: true, message: 'Enviando...', type: '' });

    try {
      const { error } = await captarLeadWeb(formData);

      if (error) {
        setStatus({ loading: false, message: 'Erro ao enviar. Tente novamente mais tarde.', type: 'error' })
      } else {
        setStatus({ loading: false, message: 'Solicitação enviada com sucesso!', type: 'success' });
        setFormData({ nomeLoja: '', telefone: '', email: '', contato: '' }); // Limpa o form
      }

    } catch (error) {
      setStatus({ loading: false, message: 'Erro ao enviar. Tente novamente mais tarde.', type: 'error' });
    }
  };

  return (
    < >

      <div className="landing-wrapper">

        <HeaderWebPage
          menuItems={BUSINESS_HEADER_MENU_ITEMS}
          headerBgColor="#356C7C"
        />

        <section id="hero">
          <div className="hero-content">
            <span className="business-landing__badge">Passarela 44 para lojistas</span>
            <h1>A moda da 44, agora a um toque de distância.</h1>
            <p>Conectamos lojistas da 44 a consumidores de todo o Brasil, porque acreditamos que moda acessível e de qualidade deve chegar a todos, não importa a distância.</p>
            <p className="microcopy">Baixe o App e aproveite!</p>
            <div className="app-buttons">
              <a href="https://apps.apple.com/br/app/passarela-44/id6758161244" target='_blank' id='btn-app-store'><img src={appStore} alt="Get It On App Store" className="img-google-play" /></a>
              <a href="https://play.google.com/store/apps/details?id=com.mobile.passarela44&pli=1" target='_blank' id='btn-google-play'><img src={googlePlay} alt="Get It On Google Play" className="img-app-store" /></a>
            </div>
          </div>
        </section>

        <section id="sobre">
          <div className="container-sobre">
            <div className="sobre-content">
              <h2>SOBRE NÓS</h2>
              <p>O App Passarela 44 nasce com o propósito de levar o melhor da moda da Região da 44, em Goiânia, a cada cantinho do nosso país, pois acreditamos que todos têm direito a vestir bem, com qualidade e preço justo.</p>
              <p>Acreditamos que a moda da 44 merece destaque: um shopping virtual próprio, à altura de sua importância. Por isso, desenvolvemos uma solução que permite aos lojistas alcançarem novos mercados, enquanto os consumidores encontram as melhores tendências da 44 com praticidade e segurança.</p>
              <p>Nosso aplicativo é a ponte inteligente que conecta a tradição das lojas da 44 à agilidade e às oportunidades do universo digital.</p>
            </div>
            <div className="sobre-features">
              {/* Card 1: Conexão Lojista <> Cliente */}
              <div className="feature-item">
                <div className="feature-icon">
                  <i className="fas fa-handshake"></i>
                </div>
                <h3>Conexão</h3>
                <p>Conectamos lojistas da 44 e consumidores de todo o Brasil em um só lugar.</p>
              </div>

              {/* Card 2: Disponibilidade 24h */}
              <div className="feature-item">
                <div className="feature-icon">
                  <i className="fas fa-history"></i>
                </div>
                <h3>Sempre Aberto</h3>
                <p>Sua vitrine disponível 24h por dia, 7 dias por semana.</p>
              </div>

              {/* Card 3: Facilidade/App */}
              <div className="feature-item">
                <div className="feature-icon">
                  <i className="fas fa-mobile-alt"></i>
                </div>
                <h3>Compra Simples</h3>
                <p>Toda a diversidade da 44 acessível com poucos toques na tela.</p>
              </div>
            </div>
          </div>
        </section>

        <section id="vitrine-lojista">
          <div className="container-vitrine">
            <div className="vitrine-grid">

              {/* Lado Esquerdo: Mockup */}
              <div className="vitrine-mockup">
                <img src={mockup} alt="Mockup da Vitrine Exclusiva" />
              </div>

              {/* Lado Direito: Texto Informativo */}
              <div className="vitrine-text">
                <span className="eyebrow">Exclusividade para sua marca</span>
                <h2>Uma vitrine digital que trabalha por você</h2>
                <div className="divider-left"></div>
                <p>No Passarela 44, sua loja não é apenas mais uma na lista. Você ganha um espaço personalizado para encantar seus clientes.</p>
                <ul className="vitrine-features">
                  <li>
                    <i className="fas fa-th-large"></i>
                    <div>
                      <h3>Produtos Organizados</h3>
                      <p>Agrupe suas peças por categorias (Blusas, Calças, Vestidos) facilitando a navegação.</p>
                    </div>
                  </li>
                  <li>
                    <i className="fas fa-tags"></i>
                    <div>
                      <h3>Gestão de Ofertas</h3>
                      <p>Destaque suas promoções e queimas de estoque com selos exclusivos de desconto.</p>
                    </div>
                  </li>
                  <li>
                    <i className="fas fa-search-plus"></i>
                    <div>
                      <h3>Busca Inteligente</h3>
                      <p>Motor de busca exclusivo dentro da sua vitrine para o cliente achar o que quer em segundos.</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section id="beneficios">
          <div className="container-beneficios">
            <h2>Por que o Passarela 44 é para você, lojista</h2>
            <div className="beneficios-grid">
              <div className="beneficio">
                <i className="fas fa-search"></i>
                <h3>Mais alcance</h3>
                <p>Seja encontrado por quem realmente importa.</p>
              </div>
              <div className="beneficio">
                <i className="fas fa-mobile-alt"></i>
                <h3>Praticidade</h3>
                <p>Venda direto pelo app, sem complicação.</p>
              </div>
              <div className="beneficio">
                <i className="fas fa-shield-alt"></i>
                <h3>Menor concorrência</h3>
                <p>Marketplace exclusivo da Região da 44.</p>
              </div>
              <div className="beneficio">
                <i className="fa-solid fa-percent"></i>
                <h3>Menor taxa do mercado</h3>
                <p>Sem mensalidades, sem taxas ocultas. Cobramos comissão por venda de 5,5%, já incluída a taxa da maquininha*.</p>
              </div>
            </div>
            <div className='beneficios-btn'>
              <a href="#faca-parte" className="secondary-cta">Quero fazer parte agora</a>
            </div>
          </div>
          <div className='beneficios-obs' >
            <p>* Taxa promocional vitalícia para os 15 primeiros lojistas cadastrados. Depois 9,5%.</p>
          </div>
        </section>
        {/*
        <section id="como-funciona">
          <div className="container-como-funciona">
            <h2>A conexão com a moda em 4 passos</h2>
            <p>É simples, rápido e você começa a usar em minutos.</p>
            <div className="timeline">
              <div className="passo">
                <span className="numero">1</span>
                <i className="fas fa-download"></i>
                <p>Baixe o App</p>
              </div>
              <div className="passo">
                <span className="numero">2</span>
                <i className="fas fa-user-plus"></i>
                <p>Crie seu perfil</p>
              </div>
              <div className="passo">
                <span className="numero">3</span>
                <i className="fas fa-users"></i>
                <p>Conecte-se</p>
              </div>
              <div className="passo">
                <span className="numero">4</span>
                <i className="fas fa-check-circle"></i>
                <p>Compre e venda</p>
              </div>
            </div>

          </div>
        </section>
*/}
        <section id="tecnologias">
          <div className="container-tecnologia">
            <h2>TECNOLOGIAS INTEGRADAS</h2>
            <p className="subtitle">Utilizamos as melhores soluções do mercado para garantir segurança e agilidade nas transações realizadas dentro do App, sempre com o objetivo de tornar a experiência do usuário a melhor possível.</p>

            <div className="tech-grid">
              <div className="tech-card">
                <div className="tech-icon stripe">
                  <img src={logoStripe} width={100} />

                </div>
                <h3>Pagamentos Seguros</h3>
                <p>Processamento via <strong>Stripe</strong>, líder mundial em pagamentos. Receba por cartão ou Pix com antecipação e segurança antifraude.</p>
              </div>

              <div className="tech-card">
                <div className="tech-icon envio">
                  <img src={logoMelhorEnvio} width={120} />
                </div>
                <h3>Frete Simplificado</h3>
                <p>Integração com <strong>Melhor Envio</strong>. Calcule fretes em tempo real e gere etiquetas de envio com descontos exclusivos nas maiores transportadoras.</p>
              </div>
            </div>
          </div>
        </section>

        {
          /*
              <section id="prova-social">
                <h2>O que dizem sobre nós</h2>
                <div className="depoimentos">
                  <div className="depoimento">
                    <img src={fotoAna} alt="Foto de Ana" className="foto-cliente" />
                    <p className="depoimento-texto">"Agora compro das minhas lojas favoritas sem sair de casa." – Ana, lojista</p>
                    <div className="avaliacao">
                      <i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i>
                    </div>
                  </div>
                  <div className="depoimento">
                    <img src={fotoCarlos} alt="Foto de Carlos" className="foto-cliente" />
                    <p className="depoimento-texto">"Encontrei fornecedores incríveis e fechei ótimos negócios." – Carlos, revendedor</p>
                    <div className="avaliacao">
                      <i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star"></i><i className="fas fa-star-half-alt"></i>
                    </div>
                  </div>
                </div>
              </section>
        */
        }
        <section id="chamada-final">
          <div className="chamada-content">
            <h2>A 44 está mais perto do que nunca!</h2>
            <p>
              Seja para ampliar suas vendas ou alcançar novos clientes, o App Passarela 44 é o seu novo ponto de encontro com quem busca a moda que você oferece.
            </p>
            <div className="act-button">
              <a href='#faca-parte' className="cta-button">Quero fazer parte agora</a>
            </div>
          </div>
        </section>

        <section id="faca-parte">
          <div className="container-faca-parte">
            <div className="faca-parte-grid">

              {/* Coluna de Texto/Chamada */}
              <div className="faca-parte-text">
                <h2>SEJA NOSSO PARCEIRO</h2>
                <p>
                  Leve seus produtos para milhares de clientes. Preencha os dados ao lado e nossa equipe entrará em contato para validar seu cadastro e abrir sua vitrine digital.
                </p>
                <ul className="beneficios-lista">
                  <li><i className="fas fa-check-circle"></i> Vitrine exclusiva no App</li>
                  <li><i className="fas fa-check-circle"></i> Suporte especializado</li>
                  <li><i className="fas fa-check-circle"></i> Gestão simples de vendas</li>
                </ul>
              </div>

              {/* Coluna do Formulário */}
              <div className="faca-parte-form">
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="nomeLoja">Nome da Loja</label>
                    <input type="text" id="nomeLoja" placeholder="Ex: Boutique da Moda" required value={formData.nomeLoja} onChange={handleChange} />
                  </div>

                  <div className="form-group">
                    <label htmlFor="telefone">Telefone / WhatsApp</label>
                    <input type="tel" id="telefone" placeholder="(62) 99999-9999" required value={formData.telefone} onChange={handleChange} />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">E-mail</label>
                    <input type="email" id="email" placeholder="seuemail@contato.com" required value={formData.email} onChange={handleChange} />
                  </div>

                  <div className="form-group">
                    <label htmlFor="contato">Nome do Responsável</label>
                    <input type="text" id="contato" placeholder="Como devemos te chamar?" required value={formData.contato} onChange={handleChange} />
                  </div>

                  <button type="submit" className="btn-enviar" disabled={status.loading}>
                    {status.loading ? 'Enviando...' : 'Enviar Solicitação'}
                    <i className="fas fa-paper-plane"></i>
                  </button>

                  {/* Feedback para o usuário */}
                  {status.message && (
                    <p className={`form-status ${status.type}`}>{status.message}</p>
                  )}
                </form>
              </div>

            </div>
          </div>
        </section>

        <section id="versiculo">
          <div className="container-versiculo">
            <div className="versiculo-grid">
              <p>"Não há santo como o Senhor; porque não há outro fora de ti; e rocha nenhuma há como o nosso Deus." 1 Samuel 2:2</p>
            </div>
          </div>
        </section>

        <FooterWebPage />

      </div>
      <BackToTop />
    </>
  )
}

export default LandingPage;
